import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import img from './img/why-choose.png';

const WhyChooseUs = () => {
    const location = useLocation();
    const [count1, setCount1] = useState(0);
  const [count2, setCount2] = useState(0);
  const sectionRef = useRef(null);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setHasStarted(true);
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!hasStarted) return;

    const animateCounter = (setCount, target) => {
      let count = 0;
      const increment = Math.ceil(target / 100); // Increment in steps for speed
      const intervalTime = 19; // Faster update time

      const interval = setInterval(() => {
        count += increment;
        if (count >= target) {
          setCount(target);
          clearInterval(interval);
        } else {
          setCount(count);
        }
      }, intervalTime);
    };

    animateCounter(setCount1, 108);
    animateCounter(setCount2, 119);
  }, [hasStarted]);
  return (
    <>
    <div className="monitor">
            <div className="code-line"> Why Choose Us...</div>
        </div>
    <div className="container-fluid bg-primary feature smooth pt-5 ">
      <div className="container pt-5">
      
        <div className="row g-5">
          <div className="col-lg-6 align-self-center mb-md-5 pb-md-5 wow fadeIn" data-wow-delay="0.3s">
          
            <h1 className="text-white mb-4">We're Best in Cyber Security</h1>
            <p className="text-light mb-5 fs-5">
            We are dedicated to delivering reliable and effective Cyber Security solutions tailored to your needs. With our expertise, you can trust us to safeguard your digital presence:
            </p>
            <div className="d-flex align-items-center text-white mb-5 whyText">
              <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                <i className="fa fa-check"></i>
              </div>
              <span>Skilled professionals with the latest cybersecurity knowledge</span>
            </div>
            <div className="d-flex align-items-center text-white mb-5 whyText">
              <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                <i className="fa fa-check"></i>
              </div>
              <span>Ability to support the Transformation initiative and provide managed services on any next-gen as well as legacy security tool  </span>
            </div>
            <div className="d-flex align-items-center text-white mb-5 whyText">
              <div className="btn-sm-square bg-white text-primary rounded-circle me-3">
                <i className="fa fa-check"></i>
              </div>
              <span>Customized solutions prioritizing your security needs to ensure that you are not spending too much on security</span>
            </div>
            <div ref={sectionRef} className="row g-4 pt-3">
              <div className="col-sm-6">
                {/* <div className="d-flex rounded p-3" style={{ background: 'rgba(256, 256, 256, 0.1)' }}>
                  <i className="fa fa-users fa-3x text-white"></i>
                  <div className="ms-3">
                    <h2 className="text-white mb-0">{count1}</h2>
                    <p className="text-white mb-0">Happy Clients</p>
                  </div>
                </div> */}
              </div>
              <div className="col-sm-6">
                {/* <div className="d-flex rounded p-3" style={{ background: 'rgba(256, 256, 256, 0.1)' }}>
                  <i className="fa fa-check fa-3x text-white"></i>
                  <div className="ms-3">
                    <h2 className="text-white mb-0">{count2}</h2>
                    <p className="text-white mb-0">Project Complete</p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-lg-6 align-self-end text-center text-md-end wow fadeIn" data-wow-delay="0.5s">
            <img className="img-fluid custom-image" src={img} loading="lazy" alt="Feature" />
          </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default WhyChooseUs